import { ValidatorInterface } from './ValidatorInterface';
import { AbstractValidator, ValidatorObject } from './AbstractValidator';
import { sprintf } from 'sprintf-js';
import Length from '../../../../source/js/shared/models/Geometry/Length';

/**
 * Validator that checks if the value is equal to or larger than the set minimum amount.
 */
export class MinimumValue extends AbstractValidator implements ValidatorInterface {

	/**
	 * Constructor.
	 *
	 * @param {ValidatorObject} options
	 */
	constructor(options: ValidatorObject) {
		super(options);

		const value = options.value ?? this.getDimensionValue();

		if (typeof value !== 'number') {
			throw new Error('The MinimumValue validator can only be used on numbers.');
		}

		this.value = value;
		this.minimum = this.minimum ?? this.getMinimum();
	}

	getMinimum(): number {
		return this.minimums[this.dimension] instanceof Length ? this.minimums[this.dimension].in_cm() : this.minimums[this.dimension];
	}

	/**
	 * @inheritDoc
	 */
	getMessage(): string {
		if (super.getCustomMessage()) {
			return super.getCustomMessage();
		}

		const { dimensions } = this.getValidatorTranslationStrings();

		if (this.getDimension() === 'number_of_points' || this.getDimension() === 'side_amount') {
			return sprintf(dimensions.min, this.getDimensionLabel(), this.minimum, '');
		}

		return sprintf(dimensions.min, this.getDimensionLabel(), this.minimum, 'cm');
	}

	/**
	 * @inheritDoc
	 */
	isValid(): boolean {
		const value = +this.value;
		if (isNaN(value)) {
			return false;
		}
		return value >= this.minimum;
	}
}
